import noop from 'lodash/noop';
import {
  getEnvVariable,
  NEXT_PUBLIC_ENV,
  NEXT_PUBLIC_ENV_VARIANT
} from './envVariablesHelper';

class Logger {
  disabled;

  constructor() {
    const currentEnv = getEnvVariable(NEXT_PUBLIC_ENV);
    // Disable logs for PROD and STAGE envs
    this.disabled =
      currentEnv === NEXT_PUBLIC_ENV_VARIANT.STAGE ||
      currentEnv === NEXT_PUBLIC_ENV_VARIANT.PROD;
  }

  log = (...params) => {
    if (this.disabled) {
      noop();
    } else {
      // eslint-disable-next-line no-console
      console.log(...params);
    }
  };

  error = (...params) => {
    if (this.disabled) {
      noop();
    } else {
      // eslint-disable-next-line no-console
      console.error(...params);
    }
  };
}

// This logger should be used for ANY logging in the application
// logger.log instead of console.log
// logger.error instead of console.error, etc.
const logger = new Logger();

export default logger;
